// extracted by mini-css-extract-plugin
module.exports = {"changeStatusQuestion":"ChangeStatusConfirmationPopupContent_changeStatusQuestion__3_YXy","container":"ChangeStatusConfirmationPopupContent_container__3Mkzr"};